import { render, staticRenderFns } from "./SiseriUploaderItemNew.vue?vue&type=template&id=6ed4f48c&"
import script from "./SiseriUploaderItemNew.vue?vue&type=script&lang=js&"
export * from "./SiseriUploaderItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports